<template>
  <b-modal
    centered
    hide-footer
    no-close-on-backdrop
    size="lg"
    header-bg-variant="orange"
    header-text-variant="white"
    id="reportShopkeepers"
    :title="modalTitle"
    body-class="p-0 pt-3"
  >
    <b-table
      hover
      fixed
      striped
      borderless
      empty-text="Não há lojistas a serem exibidos"
      :items="table.items"
      :fields="table.fields"
    ></b-table>
  </b-modal>
</template>

<script>
export default {
  name: 'ListShopkeepers',
  props: {
    shopkeepers: {
      type: Array,
      required: true,
    },
    modalTitle: {
      type: String,
      default: 'Lojistas',
    },
  },
  data() {
    return {
      table: {
        items: [],
        fields: [
          {
            key: 'fantasyName',
            label: 'Nome Fantasia',
            sortable: true,
          },
          {
            key: 'responsible',
            label: 'Nome Responsável',
          },
          {
            key: 'cellphone',
            label: 'Celular',
          },
        ],
      },
    };
  },
  watch: {
    shopkeepers() {
      this.mountTableData();
    },
  },
  methods: {
    mountTableData() {
      this.table.items = [];
      this.shopkeepers.forEach(({ fantasyName, responsible, cellphone }) => {
        if (!this.table.items.some((i) => i.cellphone === cellphone)) {
          this.table.items.push({
            fantasyName: fantasyName || '',
            responsible: responsible || '',
            cellphone: cellphone || '',
          });
        }
      });
    },
  },
};
</script>
